import Vue from 'vue'
import bootstrapVue from 'bootstrap-vue'

Vue.use(bootstrapVue)